<ng-container *ngIf="data | async as data">
  <ng-container *ngIf="data.isLoggedIn && data.groups.length === 0; else landing">
    <div id="waitingImage" class="bg-image">
      <h1 class="landing-title">{{ 'landing.title' | translate }}</h1>
      <p class="landing-text" [innerHTML]="'landing.text' | translate"></p>
    </div>
  </ng-container>
</ng-container>

<ng-template #landing>
  <div id="landingImage" class="bg-image">
    <h1 class="landing-title">{{ 'landing.title' | translate }}</h1>
  </div>
</ng-template>
